import styled from 'styled-components';
import tw from 'twin.macro';
import { motion } from 'framer-motion';

export const StyledDrawer = styled.div(() => [
  tw`fixed top-0 right-0 bottom-0 left-0`,
  `z-index: 10100;`
]);

export const ContentContainer = styled(motion.div)(() => [
  tw`fixed bg-white top-0 h-full overflow-y-auto right-0 left-auto`,
  'width: 250px;' /* Keep this value in sync with Drawer.drawerWidth static property for the animation */
]);
